export { getCriterionLabel } from './getCriterionLabel';
export { getLabel } from './getLabel';